// src/components/Footer.js
import { Link } from "react-router-dom";
import { FaPhone } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-12 pb-6 mt-20">
      <div
        className="
        max-w-7xl mx-auto px-6 
        grid grid-cols-1 md:grid-cols-3 gap-10 
        items-stretch
      "
      >

        {/* Company Info */}
<div>
  {/* Logo + Company Name in 1 line */}
  <Link to="/" className="flex items-center gap-3 mb-4">
      <h2 className="text-2xl font-bold text-white">
        PT. Inovasi Global Mumpuni
      </h2>
    </Link>

       <p className="text-white-400 font-semibold leading-relaxed">
        We focus on delivering innovative solutions across technology,
        digital infrastructure, networking systems, and enterprise
        operations supporting businesses in achieving long term growth
        and operational excellence.
       </p>
    </div>
        {/* Quick Links (centered vertically) */}
        {/* Quick Links */}
<div>
  <h3 className="text-lg font-semibold text-white mb-4 text-center md:text-left">
    Quick Links
  </h3>

  <div className="grid grid-cols-2 gap-4 text-center md:text-left">
    
    {/* Column 1 */}
    <ul className="space-y-2">
      <li>
        <Link to="/" className="hover:text-blue-400 transition">
          Home
        </Link>
      </li>
      <li>
        <Link to="/about" className="hover:text-blue-400 transition">
          About
        </Link>
      </li>
      <li>
        <Link to="/service" className="hover:text-blue-400 transition">
          Services
        </Link>
      </li>
    </ul>

    {/* Column 2 */}
    <ul className="space-y-2">
      <li>
        <Link to="/team" className="hover:text-blue-400 transition">
          Team
        </Link>
      </li>
      <li>
        <Link to="/clients" className="hover:text-blue-400 transition">
          Clients
        </Link>
      </li>
      <li>
        <Link to="/contact" className="hover:text-blue-400 transition">
          Contact
        </Link>
      </li>
    </ul>

  </div>
</div>

        {/* Contact + Location Combined */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Contact Us</h3>

          {/* Alamat */}
          <div className="flex items-start space-x-2 text-gray-400 mb-2">
            <span className="text-xl">📍</span>
            <div className="leading-relaxed">
              <p>Patra jasa Office Tower 1704</p>
              <p>Jl. Jend.Gatot Subroto Kav. 32-34</p>
              <p>Jakarta Indonesia</p>
            </div>
          </div>

          {/* Phone */}
          <div className="flex items-center space-x-2 mb-2">
            <FaPhone size={16} className="text-gray-300" />
            <a 
              href="tel:+622125024588" 
              className="text-gray-300 hover:text-blue-400"
            >
              +62 21 52900252
            </a>
          </div>

          {/* Email */}
          <div className="flex items-start space-x-2 mb-2">
            <span className="text-xl">📧</span>
            <p className="text-gray-400">info@inglom.id</p>
          </div>

          {/* Location */}
          <h3 className="text-lg font-semibold text-white mb-4 mt-6">
            Our Location
          </h3>

          <div className="rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.2300990402473!2d106.82074442355449!3d-6.233369411039781!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3e14e8cabbd%3A0xe02b42e595685bbd!2sPatra%20Jasa%20Office%20Tower!5e0!3m2!1sen!2sid!4v1761188197387!5m2!1sen!2sid"
              width="100%"
              height="180"
              style={{ border: 0, borderRadius: "8px" }}
              loading="lazy"
              allowFullScreen=""
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Maps"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-500 text-sm">
        © 2019 Inovasi Global Mumpuni. All Rights Reserved.
      </div>
    </footer>
  );
}
